'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _getAwardsPredictorCountByEventLevel = require('ifeis-isomorphic/lib/redux/actions/events/getAwardsPredictorCountByEventLevel');

var _getAwardsPredictorCountByEventLevel2 = _interopRequireDefault(_getAwardsPredictorCountByEventLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AwardsForecasterController = function () {
  function AwardsForecasterController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, AwardsForecasterController);

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this.headers = ['Level', '1', '2', '3', '4', '5', '5+', 'Grand Total'];
    this.isLoading = true;

    $ngRedux.dispatch((0, _getAwardsPredictorCountByEventLevel2.default)(feis.id)).then(function (awardsResponse) {
      _this.awardTypes = awardsResponse.payload && Object.keys(awardsResponse.payload) || [];
      _this.awardTypes.forEach(function (awardType) {
        var eventLevels = Object.keys(awardsResponse.payload[awardType]) || [];
        eventLevels.forEach(function (level) {
          var placements = awardsResponse.payload[awardType][level].relPlacement;
          var placementsToTotals = placements.reduce(function (accum, place) {
            for (var i = 1; i <= place; i++) {
              var awardCounts = accum[i];
              if (awardCounts && i < 6) {
                accum[i] = awardCounts + 1;
              } else if (i >= 6 && accum['5+']) {
                accum['5+'] = accum['5+'] + 1;
              } else if (i >= 6 && !accum['5+']) {
                accum['5+'] = 1;
              } else {
                accum[i] = 1;
              }
            }
            return accum;
          }, {});
          awardsResponse.payload[awardType][level].placementsToTotals = placementsToTotals;
        });
      });
      _this.awards = awardsResponse.payload;
    }).catch(function (error) {
      return _this.msgService.displayErrorMsg(error.message || error.toString());
    }).finally(function () {
      return _this.isLoading = false;
    });
  }

  _createClass(AwardsForecasterController, [{
    key: 'getTotal',
    value: function getTotal(awardType, rowNumber) {
      var _this2 = this;

      var eventLevels = Object.keys(this.awards[awardType]);

      return eventLevels.reduce(function (accum, level) {
        return accum + (_this2.awards[awardType][level].placementsToTotals[rowNumber] || 0);
      }, 0);
    }
  }, {
    key: 'getAwardsTotalsByColumn',
    value: function getAwardsTotalsByColumn(columnNumber) {
      var _this3 = this;

      return this.awardTypes.reduce(function (rewardAccum, awardType) {
        var awardEvents = Object.values(_this3.awards[awardType]);
        rewardAccum = rewardAccum + awardEvents.reduce(function (accum, awardEvent) {
          accum = accum + (awardEvent.placementsToTotals[columnNumber] && awardEvent.placementsToTotals[columnNumber] || 0);
          return accum;
        }, 0);
        return rewardAccum;
      }, 0);
    }
  }, {
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var _this4 = this;

      var csv = [];
      csv.push(['Awards Forecast Report']);
      csv.push(['']);
      csv.push(this.headers);
      csv.push(['']);
      Object.keys(this.awards).forEach(function (awardType) {
        csv.push(['']);
        csv.push([awardType, _this4.getTotal(awardType, 1), _this4.getTotal(awardType, 2), _this4.getTotal(awardType, 3), _this4.getTotal(awardType, 4), _this4.getTotal(awardType, 5), _this4.getTotal(awardType, '5+'), _this4.getTotal(awardType, 1) + _this4.getTotal(awardType, 2) + _this4.getTotal(awardType, 3) + _this4.getTotal(awardType, 4) + _this4.getTotal(awardType, 5) + _this4.getTotal(awardType, '5+')]);
        csv.push(['']);
        var levels = Object.keys(_this4.awards[awardType]);
        levels.forEach(function (level) {
          var levelEvent = _this4.awards[awardType][level];
          csv.push([level, levelEvent.placementsToTotals[1] || 0, levelEvent.placementsToTotals[2] || 0, levelEvent.placementsToTotals[3] || 0, levelEvent.placementsToTotals[4] || 0, levelEvent.placementsToTotals[5] || 0, levelEvent.placementsToTotals['5+'] || 0, (levelEvent.placementsToTotals[1] || 0) + (levelEvent.placementsToTotals[2] || 0) + (levelEvent.placementsToTotals[3] || 0) + (levelEvent.placementsToTotals[4] || 0) + (levelEvent.placementsToTotals[5] || 0) + (levelEvent.placementsToTotals['5+'] || 0)]);
        });
      });
      csv.push(['']);
      csv.push(['Grand Total', this.getAwardsTotalsByColumn(1), this.getAwardsTotalsByColumn(2), this.getAwardsTotalsByColumn(3), this.getAwardsTotalsByColumn(4), this.getAwardsTotalsByColumn(5), this.getAwardsTotalsByColumn('5+'), this.getAwardsTotalsByColumn(1) + this.getAwardsTotalsByColumn(2) + this.getAwardsTotalsByColumn(3) + this.getAwardsTotalsByColumn(4) + this.getAwardsTotalsByColumn(5) + this.getAwardsTotalsByColumn('5+')]);

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Awards_Forecast_Report.csv');
    }
  }]);

  return AwardsForecasterController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.awards-forecaster', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.awards-forecaster', {
    url: '/awards-forecaster',
    template: require('./tpl.html'),
    controller: AwardsForecasterController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/awards-forecaster/index.js
// module id = 557
// module chunks = 0